import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["initial", "enter"]
const _hoisted_2 = { class: "col-span-12 sm:col-span-12 lg:col-span-4 xl:col-span-4 mb-10 flex justify-center" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "col-span-12 sm:col-span-12 lg:col-span-8 xl:col-span-8" }
const _hoisted_5 = { class: "w-[100%] min-w-[280px] min-h-[250px] bg-white rounded-md p-8 flex flex-col gap-2" }
const _hoisted_6 = { class: "flex justify-start sm:flex-row flex-col gap-3" }
const _hoisted_7 = { class: "flex flex-row space-x-3 w-[91%]" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "text-h-primary-500 capitalize" }
const _hoisted_10 = { class: "flex w-[15%] flex-row" }
const _hoisted_11 = { class: "min-h-[150px] flex justify-center space-y-3 flex-col" }
const _hoisted_12 = { class: "font-[800] mt-3 sm:text-[16px] text-[12px]" }
const _hoisted_13 = { class: "sm:text-[16px] text-[14px]" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MessageVoice = _resolveComponent("MessageVoice")!
  const _component_Button = _resolveComponent("Button")!
  const _directive_motion = _resolveDirective("motion")!

  return _withDirectives((_openBlock(), _createElementBlock("section", {
    class: "grid grid-cols-12 container mx-auto w-100 sm:w-8/12 lg:w-8/12 xl:w-8/12 p-5 md:py-48 py-8",
    initial: _ctx.initialMotion,
    enter: _ctx.enterMotion
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: _ctx.alertStore?.currentMessageField?.homeroAvatar,
        class: "w-100 sm:h-64 h-48 mr-5 bg-transparent rounded-full",
        alt: "avatar-image",
        loading: "lazy"
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("img", {
              class: "w-[3%] min-w-[20px]",
              src: _ctx.alertStore?.currentMessageField?.iconTitle,
              alt: "icon title",
              loading: "lazy"
            }, null, 8, _hoisted_8),
            _createElementVNode("h4", _hoisted_9, _toDisplayString(_ctx.alertStore?.currentMessageField?.bigTitle), 1)
          ]),
          _createElementVNode("div", _hoisted_10, [
            (_ctx.alertStore?.currentMessageField?.title)
              ? (_openBlock(), _createBlock(_component_MessageVoice, {
                  key: 0,
                  msg: 
                _ctx.alertStore?.currentMessageField?.title +
                '.' +
                _ctx.alertStore?.currentMessageField?.message
              ,
                  showIconsName: false
                }, null, 8, ["msg"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.alertStore?.currentMessageField?.title), 1),
          _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.alertStore?.currentMessageField?.message), 1)
        ])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alertStore?.currentMessageField?.buttons, (button, i) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "mt-8",
          key: i
        }, [
          _createVNode(_component_Button, {
            class: _normalizeClass(`w-full ${button.color}`),
            onClick: button.action
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(button.name), 1)
            ]),
            _: 2
          }, 1032, ["class", "onClick"])
        ]))
      }), 128))
    ])
  ], 8, _hoisted_1)), [
    [_directive_motion]
  ])
}